import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import Swal from 'sweetalert2';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ClientDealCondtion extends Component {
    constructor(props) {
        super(props)
        this.state = {
           
            allConditions:[],
            condition:''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate   = this.handleUpdate.bind(this);
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        
      
    }
  
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
  
    componentDidMount() {
        this.fecthConditions();
    }
   
    toggleRightCanvas() {
        this.setState({  condition: '', isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const condition = arg;
        this.setState({
            condition: {
                id: condition.id,
                clientDealConditionId: condition.clientDealConditionId,
                clientDealConditionFor: condition.clientDealConditionFor,
                agentId: condition.agentId,
                dealCondition: condition.dealCondition,
                isActive:condition.isActive
            },
            isEdit: true,
        });
        this.toggle();
    };
 handleSubmit = (values, { setSubmitting, resetForm }) => {
     const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': str
    };
    toast.loading('Please wait....')
    const payload = {
    dealCondition: values.dealCondition,
    clientDealConditionFor: parseInt(values.clientDealConditionFor, 10), 
    agentId: parseInt(values.agentId)
  };
    axios.post(`${API_URL}ClientDealCondition`, payload, { headers })
      .then(response => {
         if (response.status === 200 && response.data.success) {
         toast.dismiss();
         toast.success('Saved successfully');
         this.fecthConditions();
          resetForm();
        } else {
        toast.dismiss();
        toast.warn(response.data.validationErrors?.[0]);
          //alert('Submission failed: ' + (response.data.validationErrors?.[0] || 'Unknown error'));
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Something went wrong!');
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  fecthConditions = () => {
      const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
      axios.get(`${API_URL}ClientDealCondition/allforagent`, {
          params: { agentId: parseInt(localStorage.getItem("userId")) },
          headers: { Authorization: str }
      })
      .then(res => this.setState({ allConditions: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
handleDelete = (id) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'This condition will be deleted permanently!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
  }).then((result) => {
    if (result.isConfirmed) {
      const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
      axios.delete(`${API_URL}ClientDealCondition/${id}`, {
        headers: { Authorization: str }
      })
      .then(() => {
        this.fecthConditions();
        Swal.fire('Deleted!', 'Condition has been deleted.', 'success');
      })
      .catch(err => {
         this.fecthConditions();
        Swal.fire('Deleted!', 'Condition has been deleted.', 'success');
      });
    }
  });
};
 handleUpdate = (values, { setSubmitting, resetForm }) => {
     const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': str
    };
    toast.loading('Please wait....')
    const payload = {
    id: values.id,
    clientDealConditionId:values.clientDealConditionId,
    dealCondition: values.dealCondition,
    clientDealConditionFor: parseInt(values.clientDealConditionFor, 10), 
    agentId: parseInt(values.agentId),
    isActive: values.isActive
  };
    axios.put(`${API_URL}ClientDealCondition`, payload, { headers })
      .then(response => {
         if (response.status === 200 && response.data.success) {
         toast.dismiss();
         toast.success('Updated successfully');
         this.fecthConditions();
        this.toggle();
        } else {
          alert('Submission failed: ' + (response.data.message || 'Unknown error'));
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Something went wrong!');
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  getApplicable(fortype){
    if(fortype==1)
        return 'Buyer offer'
    else if(fortype==2)
        return 'Seller offer'
    else
        return 'Buyer & seller offer'
  }
    render() {
        const { allConditions, condition, isEdit  } = this.state;
       
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
               
                <div className="page-content">
                    <MetaTags>
                        <title>Showing Status | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Offer Conditions")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        dealCondition: (this.state && this.state.dealCondition) || "",
                                        clientDealConditionFor:'',
                                        agentId: parseInt(localStorage.getItem('userId'))
                                    }}
                                    validationSchema={Yup.object().shape({
                                        dealCondition: Yup.string().required("This is required"),
                                        clientDealConditionFor: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Offer Conditions</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="dealCondition">
                                                                    {this.props.t("Condition *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="dealCondition"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.dealCondition && touched.dealCondition
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="dealCondition"
                                                                />
                                                                <ErrorMessage
                                                                    name="dealCondition"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>
                                                          <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="clientDealConditionFor">
                                                                    {this.props.t("Applicable to *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="clientDealConditionFor"
                                                                    onChange={handleChange}

                                                                    as="select"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.clientDealConditionFor && touched.clientDealConditionFor
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="clientDealConditionFor"
                                                                >
                                                                        <option value="">Select</option>
                                                                        <option value="1">Buyer offer</option>
                                                                        <option value="2">Seller offer</option>
                                                                        <option value="3">Buyer & seller offer</option>
                                                                    </SafeField>
                                                                <ErrorMessage
                                                                    name="clientDealConditionFor"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>
            


                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Save</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">Current Conditions</h5>
                                                    <div className="">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            {/* <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead> */}
                                                            <tbody>
                                                                {map(allConditions, (condition, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{condition.dealCondition}</td>
                                                                         <td>{this.getApplicable(condition.clientDealConditionFor)}</td>
                                                                        <td>
                                                                               <ActionEdit onClick={() => this.toggleRightCanvas(condition)} />
                                                                               <ActionDelete onClick={() => this.handleDelete(condition.id)} />
                                                                          
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: condition.id,
                                        clientDealConditionId: condition.clientDealConditionId,
                                        clientDealConditionFor: condition.clientDealConditionFor,
                                        agentId: condition.agentId,
                                        dealCondition: condition.dealCondition,
                                        isActive:condition.isActive

                                    }}
                                    validationSchema={Yup.object().shape({
                                        dealCondition: Yup.string().required("This is required"),
                                        clientDealConditionFor: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleUpdate}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                               <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="dealCondition">
                                                                    {this.props.t("Condition *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="dealCondition"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.dealCondition && touched.dealCondition
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="dealCondition"
                                                                />
                                                                <ErrorMessage
                                                                    name="dealCondition"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>
                                                          <Col sm="12">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="clientDealConditionFor">
                                                                    {this.props.t("Applicable to *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="clientDealConditionFor"
                                                                    onChange={handleChange}

                                                                    as="select"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.clientDealConditionFor && touched.clientDealConditionFor
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="clientDealConditionFor"
                                                                >
                                                                        <option value="">Select</option>
                                                                        <option value="1">Buyer offer</option>
                                                                        <option value="2">Seller offer</option>
                                                                        <option value="3">Buyer & seller offer</option>
                                                                    </SafeField>
                                                                <ErrorMessage
                                                                    name="clientDealConditionFor"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ClientDealCondtion.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
   


}
const mapStateToProps = ({  }) => (
    {

      

    })
const mapDispatchToProps = dispatch => ({

   

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientDealCondtion))
